import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import AurDataGrid from '../../../common/aur-data-grid/AurDataGrid';
import {TABLE_PAGE_SIZE_OPTION} from '../../../../constants/constants';
import {t} from 'i18next';

const DataGrid: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(25);

  const myRows = [
    {
      id: 1,
      name: 'Emma Thompson',
      email: 'emma@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 2,
      name: 'Lucas Harris',
      email: 'lucas@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 3,
      name: 'Olivia Mitchell',
      email: 'olivia@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 4,
      name: 'Ethan Roberts',
      email: 'ethan@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 5,
      name: 'Ava Scott',
      email: 'ava@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 6,
      name: 'Noah Richardson',
      email: 'noah@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 7,
      name: 'Sophia Evans',
      email: 'sophia@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 8,
      name: 'Liam Bennett',
      email: 'liam@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 9,
      name: 'Isabella Cooper',
      email: 'isabella@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 10,
      name: 'Mason Brooks',
      email: 'mason@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 11,
      name: 'Mia Foster',
      email: 'mia@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 12,
      name: 'James Peterson',
      email: 'james@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 13,
      name: 'Emily Ward',
      email: 'emily@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 14,
      name: 'Benjamin Adams',
      email: 'benjamin@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 15,
      name: 'Charlotte Reed',
      email: 'charlotte@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 16,
      name: 'Daniel Morgan',
      email: 'daniel@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 17,
      name: 'Amelia Turner',
      email: 'amelia@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 18,
      name: 'Henry King',
      email: 'henry@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 19,
      name: 'Harper Hughes',
      email: 'harper@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 20,
      name: 'Alexander Lewis',
      email: 'alexander@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 21,
      name: 'Lily Simmons',
      email: 'lily@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 22,
      name: 'Jackson Price',
      email: 'jackson@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 23,
      name: 'Grace Ross',
      email: 'grace@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 24,
      name: 'William Parker',
      email: 'william@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 26,
      name: 'Chloe Gray',
      email: 'chloe@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
    {
      id: 26,
      name: 'Samuel Phillips',
      email: 'samuel@example.com',
      role: 'Client User',
      status: 'Active',
      client: 'Acme Cartoon Corporation',
      permissiongroups: 'Report Viewer',
      workspaces: 'Acme Vs. Marvel',
    },
  ];

  const myColumns = [
    {field: 'name', headerName: 'Name', flex: 1},
    {field: 'email', headerName: 'Email Address', flex: 1},
    {field: 'role', headerName: 'Role', flex: 1},
    {field: 'status', headerName: 'Status', flex: 1},
    {field: 'client', headerName: 'Client', flex: 1},
    {field: 'permissiongroups', headerName: 'Permission Groups', flex: 2},
    {field: 'workspaces', headerName: 'Workspaces', flex: 2},
  ];

  const rowClickHandler = () => {
    alert('Row clicked');
  };
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Data Grid</h1>
        The Data Grid presents information in a structured format of rows and
        columns. The data is displayed in a user-friendly interface for
        efficient editing, reviewing, and analysis.
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurDataGrid
            rows={myRows}
            columns={myColumns}
            pageSizeOptions={TABLE_PAGE_SIZE_OPTION}
            visibleToolTip={true}
            checkBoxVisible={false}
            entityType={t('common.users')}
            className="clientDataGrid"
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            handleRowClick={rowClickHandler}
            pointer={true}
          />
        </div>
      </div>
    </>
  );
};

export default DataGrid;
